import {
  useStyle
} from "@/classify"
import Link from "next/link"
import defaultClasses from "./tile.module.css"

const Tile = (props) => {
  const {
    isActive, number, onClick, afterClick, mode, href
  } = props

  const classes = useStyle(defaultClasses, props.classes)

  const rootClass = isActive ? classes.root_active : classes.root

  const handleClick = () => {
    onClick(number)
    afterClick && afterClick()
  }

  if (mode === "button") {
    return (
      <button
        className={rootClass}
        onClick={handleClick}
        data-cy={isActive ? "Tile-activeRoot" : "Tile-root"}
        type='button'
      >
        {number}
      </button>
    )
  }

  if (mode === "link") {
    return (
      <Link
        className={rootClass}
        onClick={handleClick}
        data-cy={isActive ? "Tile-activeRoot" : "Tile-root"}
        href={href}
      >
        {number}
      </Link>
    )
  }

  return null
}

export default Tile
